import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN,role_user } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import AuthService from 'services/AuthService';
import  secureLocalStorage  from  "react-secure-storage";
import {  APP_PREFIX_PATH } from 'configs/AppConfig'

export let AUTHENTICATED_ENTRY 

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
	role : secureLocalStorage.getItem(role_user) || null,
    
}

export const checkImageAvailability = async (url) => {
	try {
	  const response = await fetch(url, { method: 'HEAD' });
	  return response.ok; // Returns true if the file exists
	} catch (error) {
	  console.error('Error checking file availability:', error);
	  return false;
	}
  };
  

export const signIn = createAsyncThunk('auth/login',async (data, { rejectWithValue }) => {
	const {email, password,user_role } = data
	try {
		const response = await AuthService.login({email, password,user_role})
        const {role,token,user,model} =await response.data;
		
		if (response.data) {
			localStorage.setItem("user" ,user)
		    localStorage.setItem("model", model)
			localStorage.setItem(AUTH_TOKEN, token); 
			
			
	    	secureLocalStorage.setItem(role_user,role)
			if (role === "MIC") {
				AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/MIC`;
			  }
			  else if(role === "admin") {
				  AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/Admin`;
			  }
			  else if(role === "ZIC") {
				  AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/ZIC`;
			  }
			  else if(role ==="hrir") {
				console.log("role" , role);
				 AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/hrir`
			  }
			  else if (role == "omc") {
				AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/omc`
			  }
			  else {
				AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/Station`;
			  }
		}
		return(token,role);
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const formatDateString = (dateString) => {
    if (!dateString) {
      return 
    }
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  export const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 because months are zero-based
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}


export const signUp = createAsyncThunk('auth/register',async (data, { rejectWithValue }) => {
	const { email, password,role } = data
	try {
		const response = await AuthService.register({email, password})
	    console.log(response)
        const token = response.data.token;
		console.log(token)
		localStorage.setItem(AUTH_TOKEN, token);
		return token;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const signOut = createAsyncThunk('auth/logout',async () => {
    const response = await FirebaseService.signOutRequest()
	localStorage.removeItem(AUTH_TOKEN);
	localStorage.removeItem("user");
	localStorage.removeItem('role_user')
	localStorage.clear()
    return response.data
})

export const signInWithGoogle = createAsyncThunk('auth/signInWithGoogle', async (_, { rejectWithValue }) => {
    try {
		const response = await AuthService.loginInOAuth()
		const token = response.data.token;
		localStorage.setItem(AUTH_TOKEN, token);
		return token;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const signInWithFacebook = createAsyncThunk('auth/signInWithFacebook', async (_, { rejectWithValue }) => {
    try {
		const response = await AuthService.loginInOAuth()
		const token = response.data.token;
		localStorage.setItem(AUTH_TOKEN, token);
		return token;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload
			state.role = action.payload
		},
		showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.role = null
			state.redirect = '/'
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload
			state.role= action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(signIn.pending, (state) => {
				state.loading = true
			})
			.addCase(signIn.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
				state.role = action.payload
			})
			.addCase(signIn.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signOut.fulfilled, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signOut.rejected, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signUp.pending, (state) => {
				state.loading = true
			})
			.addCase(signUp.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signUp.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithGoogle.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithGoogle.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithGoogle.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithFacebook.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithFacebook.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithFacebook.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const { 
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer